/**
 * @module app.cm
 */

import { autoinject, computedFrom } from 'aurelia-framework';
import { IApiSettings } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { CaseService } from 'app/cm/services/case-service';
import { apiCall } from 'app/shared/lib/api/api';
import * as CM from 'app/cm/models/essette-api';


@autoinject()
export class HouseholdCasePageContext {

    ////****************** Fields and Properties **************************************////
    public householdCase: CM.HouseholdCase = {};
    public settings: IApiSettings = {};

    @computedFrom('householdCase')
    public get isHouseholdCaseLoaded(): boolean {
        return (this.householdCase && !!this.householdCase.id);
    }


    ////****************** Lifecycle ***********************************************////
    constructor(
        private readonly caseService: CaseService,
        private readonly logger: AppLogger) {

        this.logger.source = this;
    }


    ////****************** Functions ***********************************************////
    public clear(): void {
        this.householdCase = {};
        this.settings = {};
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    public async loadHouseholdCase(householdCaseId: string, includes: string[] = []): Promise<boolean> {
        try {
            const response = await this.caseService.loadHouseholdCase(householdCaseId, includes);
            this.householdCase = response.results[0];
            this.logger.debug(`HouseholdCaseContext loaded case ${this.householdCase.number} (${this.householdCase.id})`);
            return response.isSuccessful;
        } catch(error) {
            throw error;
        }
    }

}
